var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarker = function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M16 .655a17.08 17.08 0 0 0-10.74 28.36l8.74 9.7a5.4 5.4 0 0 0 8 0l8.7-9.7A17.1 17.1 0 0 0 16 .655m2 23.38a6.42 6.42 0 1 1-.04-12.839A6.42 6.42 0 0 1 18 24.035"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 24.215a6.76 6.76 0 1 0 0-13.52 6.76 6.76 0 0 0 0 13.52"
  })));
};
export default SvgMarker;